module.exports = __webpack_public_path__ + "static/media/logo_pertamina.4e59198e.png";